"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_popper_1 = require("react-popper");
var uuid_1 = require("uuid");
var Keyboard_1 = require("../../_Core/Keyboard");
var Localization_1 = require("../../Localization");
var Dropdown_1 = require("./components/Dropdown");
var Header_1 = require("./components/Header");
var SearchableNestedDropdown_context_1 = require("./SearchableNestedDropdown.context");
var SearchableNestedDropdown_styles_1 = require("./SearchableNestedDropdown.styles");
exports.default = (function (_a) {
    var HasErrors = _a.HasErrors, _b = _a.IsDisabled, IsDisabled = _b === void 0 ? false : _b, LabelledBy = _a.LabelledBy, _c = _a.NoItemsMessage, NoItemsMessage = _c === void 0 ? Localization_1.strings.SND_Message_DefaultNoItems : _c, _d = _a.NoSearchResultsMessage, NoSearchResultsMessage = _d === void 0 ? Localization_1.strings.SND_Message_DefaultNoSearchResults : _d, OnBlur = _a.OnBlur, OnChange = _a.OnChange, OnDrillDown = _a.OnDrillDown, OnDrillUp = _a.OnDrillUp, OnDropdownOpen = _a.OnDropdownOpen, OnSearch = _a.OnSearch, _e = _a.Placeholder, Placeholder = _e === void 0 ? Localization_1.strings.SND_Message_DefaultPlaceholder : _e, _f = _a.PleaseSearchMessage, PleaseSearchMessage = _f === void 0 ? Localization_1.strings.SND_Message_DefaultSearchHelpMessage : _f, _g = _a.SearchPlaceholder, SearchPlaceholder = _g === void 0 ? Localization_1.strings.SND_Message_DefaultSearchPlaceholder : _g, _h = _a.Appearance, Appearance = _h === void 0 ? "Standard" : _h, Value = _a.Value;
    var dropdownRef = React.createRef();
    var headerRef = React.createRef();
    var headerWrapperRef = React.createRef();
    var _j = React.useState(""), helpMessage = _j[0], setHelpMessageTo = _j[1];
    var _k = React.useState(false), isDropdownOpen = _k[0], setIsDropdownOpenTo = _k[1];
    var _l = React.useState(), isLoading = _l[0], setIsLoadingTo = _l[1];
    var _m = React.useState([]), items = _m[0], setDropdownItemsTo = _m[1];
    var _o = React.useState(Value && Value.Parent), parent = _o[0], setParentTo = _o[1];
    var _p = React.useState(""), searchString = _p[0], setSearchStringTo = _p[1];
    var _q = React.useState(Value && Value.Item), value = _q[0], setValue = _q[1];
    var controlID = uuid_1.v1();
    React.useEffect(function () {
        document.addEventListener("click", handleCloseControl, false);
        return function () {
            document.removeEventListener("click", handleCloseControl, false);
        };
    }, [isDropdownOpen]);
    var handleCloseControl = function () {
        setIsDropdownOpenTo(false);
    };
    var handleOpenDropdown = function () {
        if (!IsDisabled) {
            setIsDropdownOpenTo(true);
            setIsLoadingTo(true);
            setDropdownItemsTo(undefined);
            OnDropdownOpen(value).then(function (result) {
                setIsLoadingTo(false);
                if (result) {
                    setParentTo(result.Parent);
                    setDropdownItemsTo(result.Items);
                }
                else {
                    setHelpMessageTo(PleaseSearchMessage);
                }
            }).catch(function () {
                // just drop into search mode.
                setIsLoadingTo(false);
                setHelpMessageTo(PleaseSearchMessage);
            });
        }
    };
    var handleClearControl = function () {
        setValue(undefined);
        setDropdownItemsTo(undefined);
        setSearchStringTo("");
        setIsDropdownOpenTo(false);
        OnChange();
        headerWrapperRef.current.focus();
    };
    var handleSearch = function (search) {
        setSearchStringTo(search);
        setIsLoadingTo(true);
        OnSearch(search).then(function (results) {
            setDropdownItemsTo(results);
            setIsLoadingTo(false);
            if (results.length === 0) {
                setHelpMessageTo(NoSearchResultsMessage);
            }
            else {
                setHelpMessageTo(Localization_1.strings.formatString(Localization_1.strings.SND_Message_SearchResultsNotification, results.length).toString());
            }
        });
    };
    var handleSelectFolder = function (folder) {
        setIsLoadingTo(true);
        OnDrillDown(folder).then(function (result) {
            setParentTo(result.Parent);
            setDropdownItemsTo(result.Children);
            if (result.Children.length === 0) {
                setHelpMessageTo(NoItemsMessage);
            }
            setIsLoadingTo(false);
        });
    };
    var handleSelectItem = function (item, val) {
        setIsDropdownOpenTo(false);
        OnChange(item, val);
        setValue(item);
        headerWrapperRef.current.focus();
    };
    var handleSelectParent = function (parentItem) {
        setIsLoadingTo(true);
        OnDrillUp(parentItem).then(function (result) {
            setParentTo(result.Parent);
            setDropdownItemsTo(result.Children);
            setIsLoadingTo(false);
        });
    };
    var handleControlKeyDown = function (e) {
        if ((Keyboard_1.IsDownArrow(e) || Keyboard_1.IsSpace(e) || Keyboard_1.IsEnter(e)) && !isDropdownOpen) {
            e.nativeEvent.stopImmediatePropagation();
            e.preventDefault();
            handleOpenDropdown();
        }
        else if (Keyboard_1.IsEscape(e)) {
            e.nativeEvent.stopImmediatePropagation();
            e.preventDefault();
            handleClearControl();
        }
    };
    var handleControlOnBlur = function () {
        if (OnBlur && !isDropdownOpen) {
            OnBlur();
        }
    };
    var handleSelectItemInDropdown = function () {
        dropdownRef.current.selectItemInDropdown();
    };
    var handleSelectHeaderControl = function () {
        headerRef.current.focusHeaderControl();
    };
    var popperModifiers = [
        {
            enabled: false,
            name: "flip",
        },
        {
            enabled: false,
            name: "preventOverflow",
        },
        {
            enabled: true,
            fn: function (_a) {
                var state = _a.state;
                state.elements.popper.style.width = state.elements.reference.offsetWidth + "px";
                return state;
            },
            name: "setPopperWidth",
            phase: "main",
        },
    ];
    return (React.createElement(SearchableNestedDropdown_context_1.SndContext.Provider, { value: {
            ClearControl: handleClearControl,
            HelpMessage: helpMessage,
            IsDisabled: IsDisabled,
            IsDropdownOpen: isDropdownOpen,
            IsLoading: isLoading,
            Items: items,
            LabelledBy: LabelledBy,
            OpenDropdown: handleOpenDropdown,
            Parent: parent,
            Placeholder: Placeholder,
            Search: handleSearch,
            SearchPlaceholder: SearchPlaceholder,
            SearchString: searchString,
            SelectFolder: handleSelectFolder,
            SelectHeaderControl: handleSelectHeaderControl,
            SelectItem: handleSelectItem,
            SelectItemInDropdown: handleSelectItemInDropdown,
            SelectParent: handleSelectParent,
            Value: value,
        } },
        React.createElement(react_popper_1.Manager, null,
            React.createElement(react_popper_1.Reference, null, function (_a) {
                var ref = _a.ref;
                return React.createElement("div", { ref: ref },
                    React.createElement("div", { style: { position: "absolute", zIndex: -1, opacity: 0 }, "aria-live": "assertive" }, helpMessage),
                    React.createElement(SearchableNestedDropdown_styles_1.HeaderWrapper, { Appearance: Appearance, IsDisabled: IsDisabled, IsDropdownOpen: isDropdownOpen, onKeyDown: handleControlKeyDown, onBlur: handleControlOnBlur, ref: headerWrapperRef, HasErrors: HasErrors, tabIndex: !IsDisabled ? 0 : undefined, "aria-expanded": isDropdownOpen, "arial-labelledby": LabelledBy + " " + controlID, role: "button", id: controlID, "aria-busy": isLoading, "aria-disabled": IsDisabled },
                        React.createElement(Header_1.default, { ref: headerRef })));
            }),
            React.createElement(react_popper_1.Popper, { modifiers: popperModifiers, placement: "bottom-start" }, function (_a) {
                var ref = _a.ref, style = _a.style;
                return isDropdownOpen ?
                    React.createElement(SearchableNestedDropdown_styles_1.DropdownWrapper, { ref: ref, style: style },
                        React.createElement(Dropdown_1.default, { ref: dropdownRef }))
                    : React.createElement(React.Fragment, null);
            }))));
});
